export const getHeaders = (session) => ({
  headers: {
    "X-DreamFactory-Api-Key": session.apiKey,
    "X-Client-Name": "registrationportal",
    // ...(session.sessionToken && session.sessionToken !== ""
    //   ? { "X-DreamFactory-Session-Token": session.sessionToken }
    //   : {}),
    contentType: "application/json; charset=utf-8",
  },
});

export const getFlatHeaders = (session) => ({
  "X-DreamFactory-Api-Key": session.apiKey,
  // "X-DreamFactory-Session-Token": session.sessionToken,
  "X-Client-Name": "registrationportal",
  contentType: "application/json; charset=utf-8",
});

export const getMultiPartHeaders = (session) => ({
  headers: {
    "X-DreamFactory-Api-Key": session.apiKey,
    // "X-DreamFactory-Session-Token": session.sessionToken,
    "X-Client-Name": "registrationportal",
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const getHeadersWithParams = (session, params) => ({
  headers: {
    "X-DreamFactory-Api-Key": session.apiKey,
    // "X-DreamFactory-Session-Token": session.sessionToken,
    "X-Client-Name": "registrationportal",
    "Content-Type": "multipart/form-data",
  },
  params: params,
});

export const getHeadersMultiPart = (session) => ({
  headers: {
    "X-DreamFactory-Api-Key": session.apiKey,
    // "X-DreamFactory-Session-Token": session.sessionToken,
    "X-Client-Name": "registrationportal",
    "Content-Type":
      "multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s",
  },
});

export const getImageHeaders = (session) => ({
  headers: {
    "X-DreamFactory-Api-Key": session.apiKey,
    // "X-DreamFactory-Session-Token": session.sessionToken,
    "X-Client-Name": "registrationportal",
    contentType: "application/json; charset=utf-8",
  },
});

export const getExtraImageHeaders = (session, filename) => ({
  headers: {
    "X-DreamFactory-Api-Key": session.apiKey,
    // "X-DreamFactory-Session-Token": session.sessionToken,
    "X-Client-Name": "registrationportal",
    contentType: "application/json; charset=utf-8",
    "X-File-Name": filename,
  },
});
